import { Grid, Typography, TextField } from '@mui/material';
import React from 'react';

type Props = {
  initData?: {
    link_en?: string;
    link_vi?: string;
  };
};

type States = {
  link_en: string;
  link_vi: string;
};

export class WebsiteInput extends React.Component<Props, States> {
  constructor(props: Props) {
    super(props);
    this.state = {
      link_en: props?.initData?.link_en || '',
      link_vi: props?.initData?.link_vi || '',
    };
  }

  getUrl = () => {
    return {
      link_en: this.state.link_en,
      link_vi: this.state.link_vi,
    };
  };

  updateUrl = (value: { link_en: string; link_vi: string }) => {
    this.setState(value);
  };

  render() {
    return (
      <>
        <Grid item xs={12}>
          <Typography variant="h5" p={1}>
            Website
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Vietnamese URL"
            variant="outlined"
            size="small"
            value={this.state.link_en}
            onChange={(ev) => {
              this.setState({ link_en: ev.currentTarget.value });
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="English URL"
            variant="outlined"
            size="small"
            value={this.state.link_vi}
            onChange={(ev) => {
              this.setState({ link_vi: ev.currentTarget.value });
            }}
            fullWidth
          />
        </Grid>
      </>
    );
  }
}
